import FormSelect from 'components/form/FormSelect';
import FormText from 'components/form/FormText';
import IndicatorButton from 'components/indicator/IndicatorButton';

import { useSettingMemberEdit } from './hooks/useSettingMemberEdit';
import { getDivSelectOptions } from 'utils/app';

import type { JSX } from 'react';

/**
 * カンパニーメンバー詳細画面
 */
export default function SettingMemberEdit(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const {
    initialized,
    locationState,
    processingOnSave,
    processingOnDelete,
    useFormMethods: {
      register,
      formState: { errors },
    },
    isLoginUser,
    onSave,
    onDelete,
    onBack,
  } = useSettingMemberEdit();

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {initialized && (
        <>
          <section className="section-header">
            <div className="container">
              <a onClick={onBack} className="btn-back-list hover mb-3 mt-1">
                戻る
              </a>
              <div className="d-md-flex d-flex-header">
                <div className="flex-shrink-0 flex-left">
                  <h2 className="flex-title">{locationState?.userName} さんのプロフィール</h2>
                </div>

                <div className="flex-grow-1 flex-right">
                  <ul className="list-inline list-btn mb-0">
                    {!isLoginUser && (
                      <li className="list-inline-item">
                        <button
                          onClick={onDelete}
                          className="btn btn-outline outline-blue"
                          disabled={processingOnDelete}
                        >
                          <IndicatorButton visible={processingOnDelete} />
                          ユーザーを削除する
                        </button>
                      </li>
                    )}
                    <li className="list-inline-item">
                      <button
                        onClick={onSave}
                        className="btn btn-common btn-common-w147 moderate-blue"
                        disabled={processingOnSave}
                      >
                        <IndicatorButton visible={processingOnSave} />
                        保存する
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section className="section-profile">
            <div className="container">
              <div className="box-common">
                <form className="form-profile g-3">
                  <div className="row form-row flex-md-row justify-content-between">
                    <div className="column col-lg-6 col-xl-6 col-left">
                      <FormText
                        subject="氏名"
                        name="userName"
                        register={register}
                        errors={errors}
                        required={true}
                        maxLength={100}
                        requiredMark={true}
                      />
                    </div>
                    <div className="column col-lg-6 col-xl-6 col-right">
                      <div className="form-label">ログインメールアドレス</div>
                      <p className="ms-4 fw-bold mb-0">{locationState?.userMailAddress}</p>
                    </div>
                  </div>
                  <div className="row form-row">
                    <div className="column col-lg-6 col-xl-6 col-left">
                      <FormSelect
                        subject="ユーザー権限"
                        name="roleDiv"
                        register={register}
                        errors={errors}
                        options={getDivSelectOptions('role')}
                        required={true}
                        blank={false}
                        disabled={isLoginUser}
                        requiredMark={true}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
}
